// client/src/components/admin/advertiser/AdvertiserInfoEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';


function AdvertiserInfoEditModal({ open, onClose, advertiser, onSuccess }) {
  const [formData, setFormData] = useState({
    userName: '',
    email: '',
    callNumber: '',
    marketingOption: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && advertiser) {
      setFormData({
        userName: advertiser.userName || '',
        email: advertiser.email || '',
        callNumber: advertiser.callNumber || '',
        marketingOption: advertiser.marketingOption || false
      });
      setError('');
    }
  }, [open, advertiser]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // 필드 검증
    if (!formData.userName.trim()) {
      setError('이름을 입력해주세요.');
      return;
    }
    if (!formData.email.trim()) {
      setError('이메일을 입력해주세요.');
      return;
    }
    if (!formData.callNumber.trim()) {
      setError('연락처를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/advertiser/info/${advertiser.userId}/basic`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.ok) {
        onSuccess();
        onClose();
      } else {
        setError(data.message || '정보 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('정보 수정 중 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="advertiser-info-modal">
      <div className="advertiser-info-modal__content">
        <h2 className="advertiser-info-modal__title">
          기본 정보 수정
        </h2>

        <form onSubmit={handleSubmit}>
          {/* 이름 */}
          <div className="advertiser-info-modal__form-group">
            <label className="advertiser-info-modal__label">
              이름 <span className="advertiser-info-modal__required">*</span>
            </label>
            <input
              type="text"
              name="userName"
              value={formData.userName}
              onChange={handleChange}
              className="advertiser-info-modal__input"
              placeholder="이름을 입력하세요"
            />
          </div>

          {/* 연락처 */}
          <div className="advertiser-info-modal__form-group">
            <label className="advertiser-info-modal__label">
              연락처 <span className="advertiser-info-modal__required">*</span>
            </label>
            <input
              type="text"
              name="callNumber"
              value={formData.callNumber}
              onChange={handleChange}
              className="advertiser-info-modal__input"
              placeholder="연락처를 입력하세요"
            />
          </div>

          {/* 이메일 */}
          <div className="advertiser-info-modal__form-group">
            <label className="advertiser-info-modal__label">
              이메일 <span className="advertiser-info-modal__required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="advertiser-info-modal__input"
              placeholder="이메일을 입력하세요"
            />
          </div>

          {/* 마케팅 수신 동의 */}
          <div className="advertiser-info-modal__form-group">
            <label className="advertiser-info-modal__checkbox-label">
              <input
                type="checkbox"
                name="marketingOption"
                checked={formData.marketingOption}
                onChange={handleChange}
                className="advertiser-info-modal__checkbox"
              />
              <span>마케팅 수신 동의</span>
            </label>
          </div>

          {/* 경고 메시지 */}
          <div className="advertiser-info-modal__warning">
            <strong>⚠️ 주의사항</strong>
            <ul className="advertiser-info-modal__warning-list">
              <li>수정된 정보는 즉시 반영됩니다.</li>
              <li>광고주의 기본 정보를 신중하게 수정해주세요.</li>
            </ul>
          </div>

          {/* 에러 메시지 */}
          {error && (
            <div className="advertiser-info-modal__error">
              {error}
            </div>
          )}

          {/* 버튼 */}
          <div className="advertiser-info-modal__actions">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="advertiser-info-modal__button advertiser-info-modal__button--cancel"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="advertiser-info-modal__button advertiser-info-modal__button--submit"
            >
              {loading ? '수정 중...' : '수정'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdvertiserInfoEditModal;

